import { Component, OnInit, ViewChild, NgZone, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ISubscription } from 'rxjs/Subscription';
import {} from '@types/timelinejs3';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { ManuscriptList } from '../../../models/manuscript';
import { GetMsTitlePipe } from '../../../pipes/get-ms-title.pipe';
import { DateCalendar } from '../../../models/date-range';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TimelineComponent implements OnInit, OnDestroy {
    @ViewChild('timelineJS3') timelineNode: any;
    private timeline: TL.ITimeline;
    private timelineData: TL.ITimelineConfig;
    private mssList: ManuscriptList;
    private subscriptions: Array<ISubscription> = [];

    constructor(
        private router: Router,
        private manuscriptsService: ManuscriptsService,
        private getMsTitlePipe: GetMsTitlePipe
        // private zone: NgZone
    ) {
    }

    ngOnInit() {

        /* Reset filters with reloading manuscript list */
        this.manuscriptsService.resetFilters();

        /* Load manuscript list */
        this.subscriptions.push(
            this.manuscriptsService.getManuscripts(false)
                .subscribe(response => {
                    this.mssList = response;
                    this.initTimeline();
                },
                    err => console.error(err)
                )
        );
    }

    initTimeline(): void {
        if (this.mssList && this.mssList.length > 0) {

            /* Timeline main config data init */
            this.timelineData = {
                events: [],
                title: {
                    'text': {
                        'headline': 'Time sequence of the manuscripts of Avicenna\'s Ilāhiyyāt (V-XIV c. H)',
                        // 'text': '<p>All the manuscripts from 445H to 1340H</p>'
                    },
                    'unique_id': 'timelineStart'
                },
                eras: [
                    <TL.ITimelineEra>{
                        'start_date': <TL.ITimelineDate>{
                            'year': 370
                        },
                        'end_date': <TL.ITimelineDate>{
                            'year': 410
                        },
                        'text': <TL.ITimelineText> {
                            'headline': 'Before Shifaʾ',
                            'text': 'Before Shifaʾ'
                        }
                    },
                    <TL.ITimelineEra>{
                        'start_date': <TL.ITimelineDate>{
                            'year': 410
                        },
                        'end_date': <TL.ITimelineDate>{
                            'year': 418
                        },
                        'text': <TL.ITimelineText> {
                            'headline': 'Composition of Shifaʾ',
                            'text': 'Composition of Shifaʾ'
                        }
                    },
                    <TL.ITimelineEra>{
                        'start_date': <TL.ITimelineDate>{
                            'year': 418
                        },
                        'end_date': <TL.ITimelineDate>{
                            'year': 428
                        },
                        'text': <TL.ITimelineText> {
                            'headline': 'After Shifaʾ',
                            'text': 'After Shifaʾ'
                        }
                    }
                ]
            };

            /* Load manuscript data into timeline */
            for (const manuscript of this.mssList) {
                if (manuscript.__date) {
                    const msDate = manuscript.__date[DateCalendar.Islamic];
                    if (msDate.from) {
                        const timelineMarker: TL.ITimelineSlideData = {
                            'start_date': {
                                'year': msDate.from
                            },
                            'text': {
                                'headline': manuscript.__cities + ', ' + manuscript.shelf_mark,
                                'text': this.getMsTitlePipe.transform(manuscript, 'short')
                                    + '<br><button type="button" class="btn btn-link" id="timelineMs_' + manuscript.pkid + '">'
                                    + 'Browse manuscript <i class="fa fa-angle-right"></i></button>'
                            },
                            'unique_id': 'timelineMs_' + manuscript.pkid
                        };
                        if (msDate.to && (msDate.to !== msDate.from)) {
                            timelineMarker.end_date = {
                                'year': msDate.to
                            };
                        }
                        this.timelineData.events.push(timelineMarker);
                    }
                }
            }

            /* Timeline options */
            const timelineOptions: TL.ITimelineOptions = {
                timenav_height_percentage: 70,
                /* marker_height_min: 50,  timenav_height_percentage: 10 */
            };

            /* Create timeline */
            this.timeline = new TL.Timeline('phibor-timeline', this.timelineData, timelineOptions);

            /* Activate manuscript link */
            const __this = this;
            this.timeline.on('change', () => {
                if (this.timeline.current_id !== 'timelineStart') {
                    document.getElementById(this.timeline.current_id).addEventListener('click', function (event) {
                        __this.openManuscript(__this.timeline.current_id);
                        event.stopPropagation();
                    });
                }
            });

            // this.timeline.on('dataloaded', () => { console.log('timeline loaded'); }); // dont works
        }
    }

    openManuscript(timelineMsId: string) {
        const manuscriptId = parseInt(timelineMsId.split('_')[1], 10);
        if (manuscriptId) {
            this.router.navigate(['/manuscripts/timeline', manuscriptId]);
            // this.zone.run(() => this.router.navigate(['/manuscripts/timeline', manuscriptId]));
        }
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/timeline/timeline.component.ts